import React from 'react';
import { css } from '@emotion/css';
import { useIntl } from '@/i18n/hooks/useIntl';

const styles = {
  footerTitle: css`
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    padding-bottom: 16px;
  `,
  footerText: css`
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    padding-bottom: 16px;
  `,
  linkText: css`
    color: var(--color-link-blue);
    display: flex;
    align-items: baseline;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
  `,
  tinyText: css`
    color: var(--color-text-default);
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    padding-left: 20px;
    padding-bottom: 16px;
  `,
  icon: css`
    color: var(--color-link-blue);
    padding-right: 5px;
  `,
};

export const OverviewFooter = React.memo(() => {
  const { t } = useIntl();
  return (
    <div className={'margin-top-l'}>
      <p className={styles.footerTitle}>
        {t({
          id: 'benefits.billCheckV3.modal.overview.footer.customerService',
          defaultMessage: 'Kundenservice',
        })}
      </p>
      <p className={styles.footerText}>
        {t({
          id: 'benefits.billCheckV3.modal.overview.footer.paragraph',
          defaultMessage: 'Falls du Fragen hast stehen wir dir gerne zur Verfügung:',
        })}
      </p>
      <a
        href={`tel:${t({
          id: 'benefits.billCheckV3.modal.overview.footer.phoneNumber',
          defaultMessage: '+49 30 40365750',
        })}`}
        className={styles.linkText}
      >
        <i className={`is24-icon-telephone ${styles.icon}`} />
        {t({
          id: 'benefits.billCheckV3.modal.overview.footer.phoneNumber',
          defaultMessage: '+49 30 40365750',
        })}
      </a>
      <p className={styles.tinyText}>
        {t({
          id: 'benefits.billCheckV3.modal.overview.footer.operatingHours',
          defaultMessage: 'Mo - Fr 9:00 - 18:00 Uhr',
        })}
      </p>
      <a className={styles.linkText} href='mailto:kontakt@mineko.de'>
        <i className={`is24-icon-message-email ${styles.icon}`} />
        {t({
          id: 'benefits.billCheckV3.modal.overview.footer.contactEmail',
          defaultMessage: 'kontakt@mineko.de',
        })}
      </a>
    </div>
  );
});
